
// Swiper Slider Settings

document.addEventListener('DOMContentLoaded', function () {
  function destroySwiper(swiper) {
    if (swiper && swiper.destroy) {
      swiper.destroy(true, true);
    }
  }

  function generateUniqueId() {
    return 'swiper-' + Math.random().toString(36).substr(2, 9);
  }

  function initSwiper(slider) {
    var desktopColumns = parseInt(slider.getAttribute('desktop-column'));
    var tabletColumns = parseInt(slider.getAttribute('tablet-column'));
    var mobileColumns = parseInt(slider.getAttribute('mobile-column'));
    var enablePagination = slider.getAttribute('pagination');
    var enableArrows = slider.getAttribute('arrows');
    var enableScrollbar = slider.getAttribute('scrollbar');
    var enableAutoplay = slider.getAttribute('autoplay') === 'true';
    var autoplayDelay = parseInt(slider.getAttribute('slider-delay'));
    var enableLoop = slider.getAttribute('loop') === 'true';
    var enableCentermode = slider.getAttribute('centeredSlides') === 'true';
    var sliderSpaceBetween = parseInt(slider.getAttribute('slider-space-between'));

    var paginationId = generateUniqueId();
    var nextArrowId = generateUniqueId();
    var prevArrowId = generateUniqueId();
    var scrollbarId = generateUniqueId();

    var paginationEl = slider.querySelector('.swiper-pagination');
    var nextArrowEl = slider.querySelector('.swiper-button-next');
    var prevArrowEl = slider.querySelector('.swiper-button-prev');
    var scrollbarEl = slider.querySelector('.swiper-scrollbar');

    if (enablePagination && paginationEl) {
      paginationEl.id = paginationId;
    }
    if (enableArrows && nextArrowEl && prevArrowEl) {
      nextArrowEl.id = nextArrowId;
      prevArrowEl.id = prevArrowId;
    }
    if (enableScrollbar && scrollbarEl) {
      scrollbarEl.id = scrollbarId;
    }

    return new Swiper(slider, {
      slidesPerView: mobileColumns,
      spaceBetween: sliderSpaceBetween,
      pagination: enablePagination && paginationEl ? { el: `#${paginationId}`, clickable: true } : false,
      navigation: enableArrows && nextArrowEl && prevArrowEl ? {
        nextEl: `#${nextArrowId}`,
        prevEl: `#${prevArrowId}`,
      } : false,
      scrollbar: enableScrollbar && scrollbarEl ? { el: `#${scrollbarId}`, draggable: true } : false,
      autoplay: enableAutoplay ? {
        delay: autoplayDelay,
        disableOnInteraction: false,
      } : false,
      loop: enableLoop,
      centeredSlides: enableCentermode,
      breakpoints: {
        1025: {
          slidesPerView: desktopColumns,
        },
        769: {
          slidesPerView: tabletColumns,
        },
      },
    });
  }

  function loadSliders() {
    var sections = document.querySelectorAll('[id^="section-"]');
    
    sections.forEach(function (section) {
      var sliders = section.querySelectorAll('.swiper-desktop-and-mobile, .swiper-desktop, .swiper-mobile');
      
      sliders.forEach(function (slider) {
        var isDesktop = window.matchMedia('(min-width: 769px)').matches;
        var isMobile = window.matchMedia('(max-width: 768px)').matches;
        var currentSwiper = slider.swiper;

        destroySwiper(currentSwiper);

        if (
          (slider.classList.contains('swiper-desktop-and-mobile')) ||
          (slider.classList.contains('swiper-desktop') && isDesktop) ||
          (slider.classList.contains('swiper-mobile') && isMobile)
        ) {
          slider.swiper = initSwiper(slider);
        }
      });
    });
  }

  function resizeSliders() {
    window.addEventListener('resize', function () {
      loadSliders();
    });
  }

  loadSliders();
  resizeSliders();
});

// Popup

document.querySelectorAll('.custom-open-popup').forEach(button => {
    button.addEventListener('click', function() {
        const randomNum = this.id.split('-')[1];
        const popup = document.querySelector(`.popup-${randomNum}`);
        popup.classList.add('open');
      
        const video = popup.querySelector('video'); // Select the video inside the popup
        if (video) {
            video.play();
        }
    });
});

document.querySelectorAll('.custom-close-popup').forEach(button => {
    button.addEventListener('click', function() {
        const randomNum = this.getAttribute('data-popup');
        const popup = document.querySelector(`.popup-${randomNum}`);
        popup.classList.remove('open');
      
        const video = popup.querySelector('video');
        if (video) {
            video.pause();
            video.currentTime = 0;
        }
    });
});



// Review video

document.querySelectorAll('.review_img_video').forEach(button => {
    button.addEventListener('click', function() {
        const video = this.parentElement.querySelector('video');
        const parent = this.closest('.review_img_video');

        if (video) {
            if (video.paused) {
                video.play();
            } else {
                video.pause();
            }
            video.addEventListener('play', function() {
                parent.classList.add('playing');
            });
            video.addEventListener('pause', function() {
                parent.classList.remove('playing');
            });
        } else {
            parent.classList.toggle('playing');
        }

        if (parent && !parent.classList.contains('played')) {
            parent.classList.add('played');
        }
    });
});

//cart drawer slider 

// document.addEventListener("DOMContentLoaded", function () {
//     document.querySelectorAll(".drawer--container .upsell-slider").forEach(function (slider) {
//         new Swiper(slider, {
//             slidesPerView: 1,
//             spaceBetween: 20,
//             loop: true,
//             // autoplay: {
//             //     delay: 3000,
//             //     disableOnInteraction: false,
//             // },
//             breakpoints: {
//                 569: { slidesPerView: 1.2 },
//             },
//             navigation: {
//               nextEl: '.swiper-btn-next',
//               prevEl: '.swiper-btn-prev',
//             },
//         });
//     });
// });





// document.addEventListener("DOMContentLoaded", function () {
//     document.querySelectorAll(".comp_product").forEach(function (slider) {
//         new Swiper(slider, {
//             slidesPerView: 1,
//             spaceBetween: 20,
//             loop: false,
//             // autoplay: {
//             //     delay: 3000,
//             //     disableOnInteraction: false,
//             // },
//             breakpoints: {
//                 569: { slidesPerView: 1.2 },
//             },
//             navigation: {
//               nextEl: '.swiper-btn-next',
//               prevEl: '.swiper-btn-prev',
//             },
//         });
//     });
// });

// Gift Product Functionality
document.addEventListener("DOMContentLoaded", function () {
    function attachGiftCheckboxEvent(checkbox) {
        if (checkbox && !checkbox.hasAttribute('data-event-attached')) {
            checkbox.setAttribute('data-event-attached', 'true');
            checkbox.addEventListener("change", function () {
                const variantId = this.dataset.variantId;

                if (this.checked) {
                    let formData = {
                        items: [{
                            id: parseInt(variantId),
                            quantity: 1
                        }]
                    };

                    fetch(window.Shopify.routes.root + 'cart/add.js?sections=cart-drawer', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(formData)
                    })
                    .then(response => response.json())
                    .then(data => {
                        const dataSections = data['sections'];
                        const html = new DOMParser().parseFromString(dataSections['cart-drawer'], 'text/html');
                        updateCartDrawer(html);
                    })
                    .catch(error => console.error('Error:', error));
                } else {
                    fetch(window.Shopify.routes.root + 'cart.js')
                    .then(response => response.json())
                    .then(cart => {                      
                        const giftItem = cart.items.find(item => item.variant_id == variantId);
                        if (giftItem) {
                            return fetch(window.Shopify.routes.root + 'cart/change.js?sections=cart-drawer', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify({
                                    id: giftItem.key,
                                    quantity: 0
                                })
                            });
                        }
                    })
                    .then(response => response.json())
                    .then(data => {                        
                        const dataSections = data['sections'];
                        const html = new DOMParser().parseFromString(dataSections['cart-drawer'], 'text/html');
                        updateCartDrawer(html);
                      
                        if(data.items.length<=0){
                          document.querySelector('cart-element.cart--root.cart-drawer').setAttribute('data-has-items', false);    
                        }
                    })
                    .catch(error => console.error('Error:', error));
                }
            });
        }
    }

    const initialGiftCheckbox = document.getElementById("select_gift_product");
    attachGiftCheckboxEvent(initialGiftCheckbox);

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'childList') {
                const newGiftCheckbox = document.getElementById("select_gift_product");
                if (newGiftCheckbox) {
                    attachGiftCheckboxEvent(newGiftCheckbox);
                }
            }
        });
    });

    const cartDrawer = document.querySelector('cart-element[data-view="drawer"]');
    if (cartDrawer) {
        observer.observe(cartDrawer, {
            childList: true,
            subtree: true
        });
    }
    function updateTransition(element, cssProperty, cssValue) {
        if (element instanceof Element) { 
            element.style[`${cssProperty}`] = cssValue;
            element.setAttribute('data-transition-active', "true");
            element.setAttribute('data-transition-finished', "true");
        }
    }
    function updateCartDrawer(html) {
        const cartDrawer = document.querySelector('cart-element[data-view="drawer"]')?.querySelector('.cart--form');
        if (cartDrawer) {
            const updatedCartDrawer = html.querySelector('cart-element[data-view="drawer"]')?.querySelector('.cart--form');
            if (updatedCartDrawer) {
              // console.log('updatedCartDrawer',updatedCartDrawer)
                const cartTitle = updatedCartDrawer.querySelector('.cart--title[data-item="section-heading"]');
                const shipping_bar = updatedCartDrawer.querySelector('.cart--shipping')?.querySelector('.cart--shipping-bar');
                // const subTotal = updatedCartDrawer.querySelector('.cart--total[data-item="block-heading"]');
                updateTransition(cartTitle, 'transitionDelay', '0ms');
                updateTransition(shipping_bar, 'transitionDelay', '250ms');
               
            }
            cartDrawer.outerHTML = updatedCartDrawer.outerHTML;
            reinitializeSliders();
        }
    }
});

async function reinitializeSliders() {
    document.querySelectorAll(".comp_product").forEach(function (slider) {
        if (slider.swiper) {
            slider.swiper.destroy(true, true);
        }
        
        new Swiper(slider, {
            slidesPerView: 1,
            spaceBetween: 20,
            loop: true,
            breakpoints: {
                569: { slidesPerView: 1.3 },
            },
            navigation: {
                nextEl: '.swiper-btn-next',
                prevEl: '.swiper-btn-prev',
            },
        });
    });

    document.querySelectorAll(".drawer--container .upsell-slider").forEach(function (slider) {
        if (slider.swiper) {
            slider.swiper.destroy(true, true);
        }
        new Swiper(slider, {
            slidesPerView: 1,
            spaceBetween: 20,
            loop: true,
            breakpoints: {
                569: { slidesPerView: 1.2 },
            },
            navigation: {
                nextEl: '.swiper-btn-next',
                prevEl: '.swiper-btn-prev',
            },
        });
    });
}

document.addEventListener("DOMContentLoaded", function () {
    reinitializeSliders();
});


const scrollContainer = document.querySelector("[data-layout='thumbnails-bottom'] .product-media--thumbs-wrapper");
if(scrollContainer){
  scrollContainer.addEventListener("wheel", (evt) => {
      evt.preventDefault();
      scrollContainer.scrollLeft += evt.deltaY;
  });
}

